import { mapKeys } from 'es-toolkit';
export function renameMultiBidKeys(bidParams, index) {
    if (index === 0) {
        return bidParams;
    }
    const suffix = index + 1;
    return mapKeys(bidParams, (_, key) => `${key}${suffix}`);
}
